var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewbooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #63666f;\n        stroke-miterlimit: 10;\n        stroke-width: 2.5px;\n      }\n\n      .cls-2 {\n        fill: #63666f;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073",
    transform: "translate(2595 8117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_2_Copy",
    "data-name": "Oval 2 Copy",
    className: "cls-1",
    transform: "translate(-2595 -8117)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11,
    cy: 11,
    r: 9.75
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    className: "cls-2",
    d: "M6.417,12.834a6.417,6.417,0,1,1,6.417-6.417A6.424,6.424,0,0,1,6.417,12.834ZM2.75,5.5V7.333H5.5v2.75H7.333V7.333h2.75V5.5H7.333V2.75H5.5V5.5Z",
    transform: "translate(-2590.417 -8112.417)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewbooking);
export default __webpack_public_path__ + "static/media/newbooking.4ad83be06095a972c798a6de12b3c963.svg";
export { ForwardRef as ReactComponent };